import * as Yup from 'yup';


export const ForgotSchema = Yup.object().shape({
    
    email: Yup.string()
        .email('Por favor, introduce una dirección de correo electrónico válida')
        .required('Por favor, introduce tu dirección de correo electrónico'),

});